export const Punctuation = {
    MEMBER_ACCESS: '.',
    COMMA:         ',',
    COLON:         ':',
    QUESTION_MARK: '?',
    OPEN_PAREN:    '(',
    CLOSE_PAREN:   ')',
    OPEN_BRACKET:  '[',
    CLOSE_BRACKET: ']',
    OPEN_BRACE:    '{',
    CLOSE_BRACE:   '}',
    BANG:          '!',
} as const;
